<template>
  <div class="mobile-login-container">
    <div class="mobile-header">
      <div class="logo-container">
        <img src="../../public/img/study.png" width="120px" height="120px" class="logo" />
      </div>
      <h1 class="welcome-title">欢迎回来</h1>
      <p class="welcome-subtitle">让学习更简单，让转学更轻松</p>
    </div>

    <div class="mobile-form-container">
      <form class="login-form" @submit.prevent="handleLogin">
        <!-- 用户名输入框 -->
        <div class="form-group">
          <label class="form-label" for="username">
            <i class="form-label-icon cubeic-person"></i>
            用户名
          </label>
          <div class="input-wrapper">
            <input
                id="username"
                v-model="localModel.username"
                type="text"
                class="form-input"
                :class="{ 'error': errors.username, 'focused': focusedField === 'username' }"
                placeholder="请输入用户名"
                @focus="focusedField = 'username'"
                @blur="handleBlur('username')"
                @input="clearError('username')"
            />
            <div v-if="errors.username" class="error-message">
              <i class="error-icon cubeic-alert"></i>
              {{ errors.username }}
            </div>
          </div>
        </div>

        <!-- 密码输入框 -->
        <div class="form-group">
          <label class="form-label" for="password">
            <i class="form-label-icon cubeic-lock"></i>
            密码
          </label>
          <div class="input-wrapper">
            <input
                id="password"
                v-model="localModel.password"
                :type="showPassword ? 'text' : 'password'"
                class="form-input"
                :class="{ 'error': errors.password, 'focused': focusedField === 'password' }"
                placeholder="请输入密码"
                @focus="focusedField = 'password'"
                @blur="handleBlur('password')"
                @input="clearError('password')"
            />
            <button
                type="button"
                class="password-toggle"
                @click="togglePassword"
                tabindex="-1"
            >
              <i :class="showPassword ? 'cubeic-eye-visible' : 'cubeic-eye-invisible'"></i>
            </button>
            <div v-if="errors.password" class="error-message">
              <i class="error-icon cubeic-alert"></i>
              {{ errors.password }}
            </div>
          </div>
        </div>

        <!-- 登录按钮 -->
        <button type="submit" class="mobile-login-btn" :disabled="isSubmitting">
          <span v-if="!isSubmitting">登 录</span>
          <span v-else class="loading-text">
            <i class="cubeic-loading"></i>
            登录中...
          </span>
        </button>
      </form>

      <!-- <div class="register-section">
        <p>没有账号？
          <router-link to="registered">
            <a class="register-link">立即注册</a>
          </router-link>
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { isUserExisted } from "@/api/login";

export default {
  name: 'LoginMobile',
  props: {
    model: {
      type: Object,
      required: true
    },
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localModel: {
        username: this.model.username || '',
        password: this.model.password || ''
      },
      showPassword: false,
      focusedField: '',
      errors: {
        username: '',
        password: ''
      },
      validationState: {
        username: false,
        password: false
      },
      isSubmitting: false
    };
  },
  watch: {
    model: {
      deep: true,
      handler(newVal) {
        this.localModel.username = newVal.username || '';
        this.localModel.password = newVal.password || '';
      },
      immediate: true
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = '';
      }
    },
    handleBlur(field) {
      this.focusedField = '';
      if (field === 'username') {
        this.validateUsername();
      } else if (field === 'password') {
        this.validatePassword();
      }
    },
    async validateUsername() {
      const username = this.localModel.username.trim();

      // 必填验证
      if (!username) {
        this.errors.username = '用户名为必填项';
        this.validationState.username = false;
        return false;
      }

      // 长度验证
      if (username.length < 3 || username.length > 11) {
        this.errors.username = '用户名长度为3-11个字符';
        this.validationState.username = false;
        return false;
      }

      // 用户名存在性验证
      try {
        const res = await isUserExisted(username);
        const { message } = res.data;
        if (!message) {
          this.errors.username = '用户名不存在';
          this.validationState.username = false;
          return false;
        }
      } catch (err) {
        this.errors.username = '验证失败，请稍后重试';
        this.validationState.username = false;
        return false;
      }

      this.errors.username = '';
      this.validationState.username = true;
      this.syncToParent();
      return true;
    },
    validatePassword() {
      const password = this.localModel.password.trim();

      if (!password) {
        this.errors.password = '密码为必填项';
        this.validationState.password = false;
        return false;
      }

      this.errors.password = '';
      this.validationState.password = true;
      this.syncToParent();
      return true;
    },
    syncToParent() {
      this.$emit('input', { ...this.localModel });
    },
    async validate() {
      const usernameValid = await this.validateUsername();
      const passwordValid = this.validatePassword();
      return usernameValid && passwordValid;
    },
    async handleLogin(e) {
      e.preventDefault();

      if (this.isSubmitting) return;

      // 同步数据到父组件
      this.syncToParent();

      // 验证表单
      const isValid = await this.validate();

      if (isValid) {
        this.isSubmitting = true;
        this.$emit('login');
        // 3秒后自动重置提交状态（防止卡住）
        setTimeout(() => {
          this.isSubmitting = false;
        }, 3000);
      } else {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style>
@import "../assets/stytels/login-mobile.css";
</style>

